const transactionGeneric = {
  valute: "",
  amount: 0,
  balanceAccount: "",
  counted: false,
  suspended: false
};

const transactionIn = {
  ...transactionGeneric,
  direction: "in",
  hasComission: false
};
const transactionOut = {
  ...transactionGeneric,
  direction: "out",
  hasComission: false
};

const alteration_in = {
  ...transactionGeneric,
  direction: "alteration_in",
  hasComission: false
};
const alteration_out = {
  ...transactionGeneric,
  direction: "alteration_out",
  hasComission: false
};

const transactionDepositOut = {
  ...transactionGeneric,
  direction: "deposit_out"
};
const transactionDepositIn = {
  ...transactionGeneric,
  direction: "deposit_in"
};
export default [
  {
    type: "exchange",
    title: "Обмен",
    description: "Обычная обменная операция одной валюты на другую",
    template: {
      transactions: [
        { ...transactionIn },
        { ...transactionOut }
        // {
        //   valute: "",
        //   amount: 0,
        //   direction: "in",
        //   balanceAccount: "",
        //   counted: false,
        //   suspended: false,
        //   hasComission: false
        // },
        // {
        //   valute: "",
        //   amount: 0,
        //   direction: "out",
        //   balanceAccount: "",
        //   counted: false,
        //   suspended: false,
        //   hasComission: false
        // }
      ],
      isDeposit: false,
      isCorrection: false,
      isOpex: false,
      isInternal: false,
      isEmpty: false,
      level: 1
    }
  },
  {
    type: "add-transaction",
    title: "Добавление входящей транзакции",
    description: "Обычная обменная операция одной валюты на другую",
    template: {
      transactions: [
        { ...transactionIn }
      ],
      isDeposit: false,
      isCorrection: false,
      isOpex: false,
      isInternal: false,
      isEmpty: false,
      level: 1
    }
  },
  {
    type: "deposit",
    title: "Депозит",
    description: "Операция с открытием депозита",
    template: {
      transactions: [
        { ...transactionIn },
        { ...transactionDepositOut },
        {...alteration_in},
        {...alteration_out}
        // {
        //   valute: "",
        //   amount: 0,
        //   direction: "in",
        //   balanceAccount: "",
        //   counted: false,
        //   suspended: false
        // },
        // {
        //   valute: "",
        //   amount: 0,
        //   direction: "deposit_out",
        //   balanceAccount: "",
        //   counted: false,
        //   suspended: false
        // }
      ],
      isDeposit: true,
      isCorrection: false,
      isOpex: false,
      isInternal: false,
      isEmpty: false,
      level: 1
    }
  },
  {
    type: "internal",
    title: "Движение средств",
    description: "Движение только между нашими счетами.",
    template: {
      transactions: [
        { ...transactionOut },
        { ...transactionIn }
        // {
        //   valute: "",
        //   amount: 0,
        //   direction: "out",
        //   balanceAccount: "",
        //   counted: false,
        //   suspended: false
        // },
        // {
        //   valute: "",
        //   amount: 0,
        //   direction: "in",
        //   balanceAccount: "",
        //   counted: false,
        //   suspended: false
        // }
      ],
      isDeposit: false,
      isCorrection: false,
      isOpex: false,
      isInternal: true,
      isEmpty: false,
      level: 1
    }
  },
  {
    type: "correction",
    title: "Корректировка",
    description:
      "Операция по корректировке баланса, доступна только суперадминам",
    template: {
      transactions: [
        { ...transactionIn }
        // {
        //   valute: "",
        //   amount: 0,
        //   direction: "in",
        //   balanceAccount: "",
        //   counted: false,
        //   suspended: false
        // }
      ],
      isDeposit: false,
      isCorrection: true,
      isOpex: false,
      isInternal: false,
      isEmpty: false,
      level: -1
    }
  },
  {
    type: "opex",
    title: "Операционные расходы",
    description:
      "Операция, связанная с операционными расходами (ЗП, дивиденды, прочие внутренние расходы)",
    template: {
      transactions: [
        { ...transactionOut }
        // {
        //   valute: "",
        //   amount: 0,
        //   direction: "out",
        //   balanceAccount: "",
        //   counted: false,
        //   suspended: false
        // }
      ],
      isDeposit: false,
      isCorrection: false,
      isOpex: true,
      isInternal: false,
      isEmpty: false,
      level: 1
    }
  },
  {
    type: "empty",
    title: "Свободная форма",
    description:
      "Свободная форма, для сложных случаев, доступна только суперадминам",
    template: {
      transactions: [],
      isDeposit: false,
      isCorrection: false,
      isOpex: false,
      isInternal: false,
      isEmpty: true,
      level: -1
    }
  }
];



// WEBPACK FOOTER //
// ./src/components/pages/Ledger/exchangeTemplates.js